<template>
    <div>
      <div class="ds-header">
        <div class="ds-title">
            Estoque
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
            <button
                class="btn btn-primary float-right mb-3"
                @click="openModal"
            >
                Novo Estoque
            </button>
        </div>
      </div>

      <b-table-simple class="table table-bordered">
        <thead>
          <tr>
            <th scope="col">Estoque</th>
            <th scope="col">Setor</th>
            <th scope="col" style="width: 100px;"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(location, indx) in locations" :key="'location-' + indx">
            <td>
              {{ location.name }}
            </td>
            <td>
                <span class="badge badge-pill badge-gray mr-2">{{ location.sectors.length ? location.sectors[0].name : '-' }}</span>
                <span class="badge badge-pill badge-primary" v-if="location.sectors.length > 1" :id="'popover-target-' + indx">+{{ (location.sectors.length - 1) }}</span>
                <b-popover :target="'popover-target-' + indx" triggers="hover" placement="top">
                    <template #title>Setor:</template>
                    <ul class="sectors">
                      <li v-for="(sector, i) in location.sectors" :key="i">
                        {{ sector.name }}
                      </li>
                    </ul>
                </b-popover>
            </td>
            <td>       
                <div class="toolbar"> 
                    <Icon v-if="location.clinic_id">
                      <toggle-button 
                        class="toggle-button toolbar__item" 
                        :color="{checked: '#00C773', unchecked: '#E1E5F4'}" 
                        :value="!!location.status.enable"
                        v-model="location.status.enable"
                        @input="updateStatusLocation(location)"/>
                    </Icon>
                    <Icon v-if="location.clinic_id">
                        <Edit class="icon-edit toolbar__item" v-b-tooltip.hover :title="'Editar estoque'" @click="edit(indx)"/>
                    </Icon>
                    <Icon v-if="location.clinic_id">
                        <Trash class="icon-trash toolbar__item" v-b-tooltip.hover :title="'Remover estoque'" @click="remove(indx)"/>
                    </Icon>
                </div> 
            </td>
          </tr>
        </tbody>
      </b-table-simple>

      <Location
        @reload="getLocations"
        :location="selectLocation"
      />

    </div>

</template>
<script>
import { userHasPermission, getCurrentClinic } from '@/utils/localStorageManager'
export default {
  components: {
    Location: () => import('./LocationModal.vue'),
    Icon: () => import('@/components/General/Icon'),
    Edit: () => import('@/assets/icons/edit.svg'),
    Trash: () => import('@/assets/icons/trash.svg'),
  },
  mounted() {
    this.getLocations();
  },
  props: {
    // 
  },
  data() {
    return {
      canEditModule: userHasPermission('EstConf2'),
      canEditPreferences: userHasPermission('EstConf3'),
      clinic: getCurrentClinic(),
      selectedFields: {},
      locations: [],
      selectLocation: {}
    }
  },
  methods: {
    getLocations() {
      const isLoading = this.$loading.show();
      this.api.getWarehouseLocations(this.clinic.id)
      .then(res => {
        this.locations = res.data;
      })
      .catch(err => this.$toast.error(err.message))
      .finally(() => isLoading.hide());
    },
    openModal() {
      this.selectLocation = {};
      this.$bvModal.show('location-modal');
    },
    edit(indx) {
      this.selectLocation = this.locations[indx];
      this.$bvModal.show('location-modal');
    },
    remove(indx) {
      this.$swal({
        icon: 'question',
        html: `<div class="body-alert">Você tem certeza que deseja excluir esse registro? Não será possível reverter essa ação.</div>`,
        showCancelButton: true,
        confirmButtonColor: '#F63220',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
       }).then(res => {
        if (res.isConfirmed) {
          this.api.deleteWarehouseLocation(this.locations[indx].id).then(res => {
            this.locations.splice(indx, 1);
          })
          .catch(err => {
            if(err.response?.data?.message){
              this.$toast.error(err.response.data.message)
            } else {
              this.$toast.error(err.message)
            }
          });
        }
      });
    },
    updateStatusLocation(location) {
      if(location.status.enable){
        this.api.enableWarehouseLocation(this.clinic.id, location.id).then(res => {
          this.$toast.success("Cadastro habilitado com sucesso!");
        });
      } else {
        this.api.disableWarehouseLocation(this.clinic.id, location.id).then(res => {
          this.$toast.success("Cadastro desabilitado com sucesso!");
        });        
      }
    }    
  },
}
</script>
<style lang="scss" src="@/assets/scss/table.scss" />
<style lang="scss" scoped>
.sectors {
  list-style-type: none;
  padding: 0px;
  width: 100px;
  font-family: Nunito Sans;
  font-size: 14px;
  line-height: 24px;
}

.badge{
  font-size: max(12px, 0.7vw);

  &.badge-gray {
    background: #F4F5FB;
    color: #525C7A;
    font-weight: 500;
  }

  &.badge-primary {
    background: #305BF2;
  }
}

.ds-container {
  padding: 30px 10px;

  .ds-header {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 35px 0px 10px 0px;
  }

  .ds-title {
    display: inline-flex;
    align-items: center;
    font-family: 'Red Hat Display';
    font-weight: 500;
    font-size: 18px;
  }

  .nav-link {
    font-size: 14px;
    margin: 2px 3px;
    padding: 0 10px;
    border: 1px solid #D9DFF2;
    border-radius: 100px;
    cursor: pointer;
    color: var(--type-active);

    &.active {
      background-color: #F4F5FB;
    }
  }

  .table {
    border: 1px solid #C6CEEB;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;

    thead {
      th {
        background: #F4F5FB;
        color: #525C7A;
        border: none;
        border-bottom: 1px solid #dee2e6;
      }
    }
    tbody {
      td {
        padding: 0.35rem;
        vertical-align: middle;
        color: #525C7A;
        height: 45px;
        border: none;
        border-bottom: 1px solid #dee2e6;

        .link-add {
          color: #305BF2;
          font-size: 16px;
          font-weight: 700;
          line-height: 24px;
        }

        .default {
          color: #8696AC;
          font-size: 12px;
        }

      }
    }

    .toolbar {
      display: flex;
      justify-content: flex-start;
      margin: auto;

      .icon-container {
        min-width: 33px;
      }

      .toolbar__item {
        margin: 0px 5px;
        width: 23px;
        height: 23px;
        cursor: pointer;

        &.vue-js-switch {
          margin-right: 27px;

        }
      }

      .icon-trash {
        path {
          stroke: #FBA59D;
        }
      }

    }
  }

}

.option {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.togle-button {
  margin-left: 10px;
}
</style>
